import { Dispatch, SetStateAction, createContext, useState } from 'react'

type NavContextType = {
  navOpen: boolean
  setNavOpen: Dispatch<SetStateAction<boolean>>
}
export const NavContext = createContext<NavContextType>({
  navOpen: false,
  setNavOpen: {} as any,
})

export const NavContextProvider = ({ children }) => {
  const [navOpen, setNavOpen] = useState<boolean>(false)
  return (
    <NavContext.Provider
      value={{
        navOpen,
        setNavOpen,
      }}
    >
      {children}
    </NavContext.Provider>
  )
}
